import { IEbtidaResultProps } from "../../../Interfaces/IEbtidaResultProps";
import { EbtidaAnalysisColumns } from "../../../Static/AnalysisColumns";
import CustomTableComponent from "../../Shared/CustomTable";

interface IEbtidaAnalysisComponentProps {
    rowEbtidaResults: IEbtidaResultProps[],
}

const EbtidaAnalysisComponent = (props: IEbtidaAnalysisComponentProps) => {
    return (
        <div className='pagination-tab-body d-flex flex-column mb-2 mt-3'>
            <span className='text-center mb-2'><b>Análise Ebitda:</b></span>
            <CustomTableComponent
                rows={props.rowEbtidaResults}
                hasHeader={false}
                columns={EbtidaAnalysisColumns}
                isTableInverted={true}
            />
        </div>
    )
}

export default EbtidaAnalysisComponent;